/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type TransformationRunDto = {
    durationMillis?: number;
    endTime?: number;
    estimatedCostCents?: number;
    logs?: string;
    startTime?: number;
    status?: TransformationRunDto.status;
};

export namespace TransformationRunDto {

    export enum status {
        PENDING = 'PENDING',
        RUNNING = 'RUNNING',
        SUCCESS = 'SUCCESS',
        WARNING = 'WARNING',
        REUSED = 'REUSED',
        FAILURE = 'FAILURE',
        SKIPPED = 'SKIPPED',
        NO_OP = 'NO_OP',
    }


}
